import { message } from "antd";
import apiHelper from "./apiHelper";

export const createJob = async (body: any) => {
  const url = "/jobs";
  const response: any = await apiHelper.post(url, { ...body });
  if (response.data.statusCode === 201) {
    return { success: true };
  }
  throw new Error(response.data.message);
};

export const getJobData = async (date?: string) => {
  const url = date ? `/jobs/all?updatedAt=${date}` : "/jobs/all";
  const response: any = await apiHelper.get(url, {});
  if (response.data.statusCode === 200) {
    return response.data.data;
  }
  return [];
};

export const getJobDataById = async (id: any) => {
  const url = `/jobs/${id}`;
  const response: any = await apiHelper.get(url, {});
  if (response.data.statusCode === 200) {
    return response.data.data;
  }
  return { error: "Invalid" };
};

export const getJobRunsById = async (id: any) => {
  const url = `/jobs/${id}/runs`;
  const response = await apiHelper.get(url, {});

  if (response.data.statusCode === 200) {
    return response.data.data.map((run: any) => {
      return {
        ...run,
        id: run.self_uri.split("/runs/")[1]
      };
    });
  }

  message.error("Error fetching data / Data does not exist");
  return [];
};

export const moveJobToQueue = async (id: any) => {
  const url = `/jobs/${id}`;
  const response: any = await apiHelper.patch(url, {
    job_status: "in queue"
  });
  if (response.data.statusCode === 200) {
    return response.data.data.data;
  }
  return { error: "Invalid" };
};

export const deleteJob = async (id: any) => {
  const url = `/jobs/${id}`;
  const response: any = await apiHelper.delete(url, {});
  if (response.data.statusCode === 200) {
    message.success(response.data.message);
    return { success: true };
  }

  message.error(response.data.message);
  return { error: true };
};

export const cancelJob = async (id: string) => {
  const url = `/jobs/cancel/${id}`;
  const response = await apiHelper.patch(url, {});
  if (response.data.statusCode === 200) {
    return { success: true };
  }
  if (response?.data?.message) {
    message.error(response?.data?.message);
  }
  return { error: true };
};

export const calculateJob = async (
  nPhotons: string,
  nModes: string,
  nEvents: string,
  type: string
) => {
  const url = `/jobs/${nPhotons}/${nModes}/${nEvents}/${type}`;
  const response: any = await apiHelper.get(url, {});
  if (response.data.statusCode === 200) {
    return { success: true, data: response.data.data };
  }
  return { error: true, message: response.data.message };
};

export const getHistogramData = async (jobId: string) => {
  // const url = `/histogram/${jobId}/${runId}`;
  const url = `/histogram/${jobId}`;
  const response: any = await apiHelper.get(url, {});
  if (response.data.statusCode === 200) {
    return { success: true, data: response.data.data };
  }
  return { error: true };
};
